import { HStack, Stack, Text, VStack, Slack, SimpleGrid } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";
import { useEffect } from "react";

const SelectPeriod = observer(() => {
  const { pageStore } = useStores();

  const setYesterday = () => {
    const date = new Date();

    const end = new Date(date);
    end.setDate(date.getDate());
    end.setHours(23, 59, 59, 999);

    const start = new Date(end);
    start.setDate(date.getDate());
    start.setHours(23, 59, 59, 999);

    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  const setWeek = () => {
    const date = new Date();
    const start = new Date(date);
    const dayOfWeek = start.getDay() || 7;
    start.setDate(start.getDate() - dayOfWeek + 1);
    start.setHours(23, 59, 59, 999);

    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    end.setHours(23, 59, 59, 999);

    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  const setMonth = () => {
    const date = new Date();
    const start = new Date(date.getFullYear(), date.getMonth(), 1);
    start.setHours(23, 59, 59, 999);
    const end = new Date(start.getFullYear(), start.getMonth() + 1, 0);
    end.setHours(23, 59, 59, 999);

    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  const setQuarter = () => {
    const date = new Date();
    const quarterStartMonth = Math.floor(date.getMonth() / 3) * 3;
    const start = new Date(date.getFullYear(), quarterStartMonth, 1);
    start.setHours(23, 59, 59, 999);
    const end = new Date(start.getFullYear(), start.getMonth() + 3, 0);
    end.setHours(23, 59, 59, 999);

    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  const setFirstHalfYear = () => {
    const date = new Date();
    const start = new Date(date.getFullYear(), 0, 1);
    start.setHours(23, 59, 59, 999);
    const end = new Date(date.getFullYear(), 5, 30);
    end.setHours(23, 59, 59, 999);
    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  const setSecondHalfYear = () => {
    const date = new Date();
    const start = new Date(date.getFullYear(), 6, 1);
    start.setHours(23, 59, 59, 999);
    const end = new Date(date.getFullYear(), 11, 31);
    end.setHours(23, 59, 59, 999);
    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  const setYearToDate = () => {
    const date = new Date();
    const start = new Date(date.getFullYear(), 0, 1);
    start.setHours(23, 59, 59, 999);
    const end = new Date(date);
    end.setHours(23, 59, 59, 999);
    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  const setTwoYear = () => {
    const date = new Date();
    const start = new Date(date.getFullYear() - 1, 0, 1);
    const end = new Date(date.getFullYear(), 11, 31, 23, 59, 59, 999);

    start.setHours(23, 59, 59, 999);

    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  const setThreeYear = () => {
    const date = new Date();
    const start = new Date(date.getFullYear() - 2, 0, 1);
    const end = new Date(date.getFullYear(), 11, 31, 23, 59, 59, 999);

    start.setHours(23, 59, 59, 999);

    pageStore.updateStartDateDay(start.toISOString().split("T")[0]);
    pageStore.updateEndDateDay(end.toISOString().split("T")[0]);
  };

  useEffect(() => {
    // Период восстановлен из сохранённой настройки: даты уже пришли из неё,
    // пересчитывать их «от сегодня» нельзя. Раньше первый выбор настройки
    // затирал сохранённый период, а второй клик срабатывал верно — потому
    // что значение пресета уже не менялось и эффект не запускался.
    if (pageStore.period_from_bind) {
      pageStore.clearPeriodFromBind();
      return;
    }

    pageStore.updateStartDateMonth("");
    pageStore.updateEndDateMonth("");
    if (pageStore.selected_period == "yesterday") {
      setYesterday();
    } else if (pageStore.selected_period == "week") {
      setWeek();
    } else if (pageStore.selected_period == "month") {
      setMonth();
    } else if (pageStore.selected_period == "quarter") {
      setQuarter();
    } else if (pageStore.selected_period == "firstHalfYear") {
      setFirstHalfYear();
    } else if (pageStore.selected_period == "secondHalfYear") {
      setSecondHalfYear();
    } else if (pageStore.selected_period == "yearToDate") {
      setYearToDate();
    } else if (pageStore.selected_period == "twoYear") {
      setTwoYear()
    } else if (pageStore.selected_period == "threeYear") {
      setThreeYear()
    } else {
      pageStore.updateStartDateDay("");
      pageStore.updateEndDateDay("");
    }
  }, [pageStore.selected_period]);

  return (
    <VStack padding={"10px"} width={"100%"} borderRadius={"0px"}>
      <SimpleGrid
        mt="10px"
        columns={{ base: 3, sm: 5, md: 9, lg: 9 }}
        spacing={1}
        width="100%"
      >
        {[
          { id: "yesterday", label: "День" },
          { id: "week", label: "Неделя" },
          { id: "month", label: "Месяц" },
          { id: "quarter", label: "Квартал" },
          { id: "firstHalfYear", label: "1-е полугодие" },
          { id: "secondHalfYear", label: "2-е полугодие" },
          { id: "yearToDate", label: "С начала года" },
          { id: "twoYear", label: "2 года" },
          { id: "threeYear", label: "3 года" },
        ].map((period) => (
          <Stack
            key={period.id}
            onClick={() => pageStore.updateSelectedPeriod(period.id)}
            height={"40px"}
            bg={pageStore.selected_period === period.id ? "#555" : "#333"} // Подсветка активного периода
            borderColor={"#444"}
            justify={"center"}
            align={"center"}
            borderWidth={"1px"}
            borderRadius={"4px"}
            padding={"5px"}
            cursor={"pointer"}
            color={"white"}
            _hover={{ background: "#444" }}
            transition="all 0.2s"
          >
            <Text fontSize={{ base: "13px", md: "14px" }}>{period.label}</Text>
          </Stack>
        ))}
      </SimpleGrid>
    </VStack>
  );
});

export default SelectPeriod;
